import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var ReviewSummaryQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ReviewSummaryQuery($productId: String!) {\n    reviewSummary(productId: $productId) {\n      productId\n      summary\n      tags\n    }\n  }\n"])));
export default ReviewSummaryQuery;